import { skipToken, useInfiniteQuery } from '@tanstack/react-query';

import { Canvases } from '@air/api';
import { callAirApi } from '@air/utils-api';

import { type CanvasThreadsList } from './types';

export const PRIVATE_CANVAS_THREADS_LIST_KEY = 'PRIVATE_CANVAS_THREADS_LIST';

export type PrivateCanvasThreadsListParams = {
  workspaceId: string | undefined;
  canvasId: string | undefined;
};

export const getPrivateCanvasThreadsListKey = (params: PrivateCanvasThreadsListParams) => {
  return [PRIVATE_CANVAS_THREADS_LIST_KEY, params];
};

export type UsePrivateCanvasThreadsListOptions = {
  enabled?: boolean;
};

export const usePrivateCanvasThreadsList = (
  params: PrivateCanvasThreadsListParams,
  options?: UsePrivateCanvasThreadsListOptions,
) => {
  const { workspaceId, canvasId } = params;

  return useInfiniteQuery({
    enabled: !!workspaceId && !!canvasId && (options?.enabled ?? true),
    getNextPageParam: (lastPage: CanvasThreadsList) => lastPage?.pagination?.cursor ?? undefined,
    initialPageParam: '',
    queryFn:
      workspaceId && canvasId
        ? async ({ pageParam }) =>
            callAirApi(() => Canvases.Threads.list({ canvasId, cursor: pageParam || undefined, workspaceId }))
        : skipToken,
    queryKey: getPrivateCanvasThreadsListKey(params),
    staleTime: Infinity,
  });
};
